






















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { isIos } from "@/utils/lodash";
import LocalizeUtil from "@/services/payment/localize";
import RecommendUtil from "@/utils/recommend_util/recommend_util";
@Component({
  components: { swiper, swiperSlide }
})
export default class VipBenefit extends Vue {
  private slideIndex = 0;
  private showSwiper = false;
  private recommendList = [];

  get swiperOptions() {
    return {
      loop: true,
      autoplay: true,
      observer: true,
      pagination: {
        el: ".swiper-pagination"
      },
      initialSlide: this.slideIndex,
      observeParents: false
    };
  }
  get swiperList() {
    let dayMoney: any = "";
    let monthMoney: any = "";
    if (isIos()) {
      dayMoney = LocalizeUtil.getLocalizePriceByPrice("$4.99");
      monthMoney = LocalizeUtil.getLocalizePriceByPrice("$119.99");
    } else {
      dayMoney = LocalizeUtil.getLocalizePriceByPrice("$3.99");
      monthMoney = LocalizeUtil.getLocalizePriceByPrice("$49.99");
    }
    const origin_arr = [
      {
        icon: require("@/assets/icons-file/vip/crown.png"),
        title: `Become VIP`,
        content: `Upgrade for the exclusive privileges and all <span>following full features.</span> 👉`
      },
      {
        iconFont: "icon-app_golden",
        title: "10 Daily Bonus Followers",
        content: `+10 golden followers (<span>worth ${dayMoney}</span>) <span>every day</span> to keep your followers growing steadily (totally <span>worth ${monthMoney}/month</span>)⚡️⚡️⚡️`
      },
      {
        icon: require("@/assets/icons-file/more/more_bonus.png"),
        title: `<div class="bonus_width">10% More on All <span>👤 ❤️</span> Orders</div>`,
        content: `<span>Exclusive 10% bonus</span> for all followers, likes, comments and views orders.`
      },
      {
        icon: require("@/assets/icons-file/more/ico_tab5_exclusivevipdiscount@3x.png"),
        title: "Exclusive VIP Discount",
        content: `<span>4 super big discount</span> coins packages exclusive for VIP member every month (<span>save ${LocalizeUtil.getLocalizePriceByPrice(
          "$59.99"
        )} /month</span>)!`
      },
      {
        icon: require("@/assets/icons-file/more/no_folllowers_drop@3x.png"),
        title: `No Followers Drop <span>🔰</span>`,
        content: `We will <span>compensate</span> you with <span>extra followers</span> if anyone unfollows you in the first week.`
      },
      {
        icon: require("@/assets/icons-file/more/ico_tab5_moreactive@2x.png"),
        title: "More Active & Real Followers",
        content: `See great growth in <span>more real, passionate, interested and engaged</span> followers.`
      },
      {
        icon: require("@/assets/icons-file/more/faster@3x.png"),
        title: "300% Higher-Speed Growth",
        content: `Your <span>orders</span> of followers, likes or views will be delivered <span>300% faster</span> than non-VIP members.`
      },

      {
        icon: require("@/assets/icons-file/more/ico_tab5_24personalconsultant@3x.png"),
        title: "24/7  Personal Consultant",
        content: `Your personal consultant is <span>available 24/7</span> to assist with all your needs.`
      },
      {
        icon: require("@/assets/icons-file/more/ads@3x.png"),
        title: "Remove ADS",
        content: `Enjoy a completely <span>AD FREE</span> experience.`
      }
    ];
    if (this.recommendList && this.recommendList.length > 0) {
      origin_arr.splice(7, 0);
    }
    return origin_arr;
  }
  private clickVipBenefit() {
    this.$emit("clickVipBenefit");
  }
  private async mounted() {
    this.showSwiper = true;
    this.recommendList = await RecommendUtil.getRecommendList();
  }
  private activated() {
    this.showSwiper = true;
  }
  private deactivated() {
    this.showSwiper = false;
  }
}
